import { Component, Inject, OnInit } from '@angular/core';
import { IncidentType } from '../../entities/global/model';
import { SafetyConfigService } from '../../services/safety-config.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-incidenttype-dialog',
  templateUrl: './add-incidenttype-dialog.component.html',
  styleUrls: ['./add-incidenttype-dialog.component.css']
})
export class AddIncidenttypeDialogComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<AddIncidenttypeDialogComponent>,
    private _safetyConfigService:SafetyConfigService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

    selectedName:string="";
    selectedDescription:string="";


  ngOnInit() {
  }
  DialogClose(){
    this.dialogRef.close(false)
  }
  addIncident(){

    let model= new IncidentType()
    model.Name=this.selectedName;
    model.Description=this.selectedDescription
    console.log('input values',model)
this._safetyConfigService.CreateIncidentType(model).subscribe(res =>{
 
  if(res.m_Item1=true){
    console.log('result', res)
    this.DialogClose();
   

  }});
    
  }

}

